import { render, staticRenderFns } from "./ModalResponderRecursoContrarrazao.vue?vue&type=template&id=1f89be96"
import script from "./ModalResponderRecursoContrarrazao.vue?vue&type=script&lang=js"
export * from "./ModalResponderRecursoContrarrazao.vue?vue&type=script&lang=js"
import style0 from "./ModalResponderRecursoContrarrazao.vue?vue&type=style&index=0&id=1f89be96&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports